export default __webpack_public_path__ + "static/backgroundImageMobile-6a165ae2f0d53c89c7abd18ea7d528d1.png";